import { onDidLoad } from '@atomify/hooks';
import { Dimensions, ScreenCoordinates } from '@features/virtual-tour/types';

export interface ResizingViewportHookProps {
    viewport: { current: HTMLElement | null };
    onResize: (dimensions: Dimensions) => void;
}

export const useResizableViewport = ({ viewport, onResize }: ResizingViewportHookProps) => {
    const dimensions: Dimensions = {
        width: 0,
        height: 0,
    };

    const position: ScreenCoordinates = {
        x: 0,
        y: 0,
    };

    const getViewportElementRect = () => {
        const { width, height, x, y } = viewport.current!.getBoundingClientRect();
        const widthFloored = Math.floor(width);
        const heightFloored = Math.floor(height);

        return { width: widthFloored, height: heightFloored, x, y };
    };

    const refresh = () => {
        const { width, height, x, y } = getViewportElementRect();
        position.x = x;
        position.y = y;

        if (dimensions.width !== width || dimensions.height !== height) {
            dimensions.width = width;
            dimensions.height = height;
            onResize(dimensions);
        }
    };

    onDidLoad(() => {
        if (!viewport.current) return;
        refresh();
    });

    return { dimensions, position, refresh };
};
